import { ArrowCircleUpSharp, FiberManualRecord } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Header from "../elements/Header";
import Sidebar from "../elements/Sidebar";
import policyService from "../services/policyService";
import { blueGradientBackground, pink } from "../shared/colours";
import { borderStyle, cardStyle, contentBoxStyle } from "../shared/Theme";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PoliciesModal from "../elements/Policy/PoliciesModal";
import PolicyPercentBar from "../elements/Policy/PolicyPercentBar";
import PolicyUploadModal from "../elements/Policy/PolicyUploadModal";
import PolicyTemplatesModal from "../elements/Policy/PolicyTemplatesModal";
import SendPoliciesModal from "../elements/Policy/SendPoliciesModal";
import PolicyAuditorModal from "../elements/Policy/PolicyAuditorModal";
import AccountGuard from "../elements/Admin/AccountGuard";

const Policies = () => {
	
	let [ showPolicies, setShowPolicies ] = useState(false);
	let [ showSendPolicies, setShowSendPolicies ] = useState(false);
	let [ showAuditPolicies, setShowAuditPolicies ] = useState(false);
	let [ showPolicyUpload, setShowPolicyUpload ] = useState(false);
	let [ showPolicyTemplates, setShowPolicyTemplates ] = useState(false);
	
	const handlePoliciesClick = () => { 
		setShowPolicies(true);
	};
	
	const handlePoliciesModalClose = () => { 
		setShowPolicies(false);
	};
	
	const handleSendPoliciesClick = () => { 
		setShowSendPolicies(true);
	};
	
	const handleSendPoliciesModalClose = () => { 
		setShowSendPolicies(false);
	};
	
	const handleAuditPoliciesClick = () => { 
		setShowAuditPolicies(true);
	};
	
	const handleAuditPoliciesModalClose = () => { 
		setShowAuditPolicies(false);
	};
	
	const handlePolicyTemplatesClick = () => { 
		setShowPolicyTemplates(true);
	};
	
	const handlePolicyTemplatesModalClose = () => { 
		setShowPolicyTemplates(false);
	};
	
	const handlePolicyClick = (policy) => { 
		policyService.downloadCompanyPolicy(policy);
	};
	
	const handlepolicyUploadClick = () => {
		setShowPolicyUpload(true);
	};
	
	const handlePolicyUploadModalClose = () => {
		setShowPolicyUpload(false);
	}
	
	const handleUploadPolicySubmit = async (policy) => {
		await policyService.addCompanyPolicy(policy);
		setShowPolicyUpload(false);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<AccountGuard requiredService="usecure"/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Policies"/>
				<Box sx={contentBoxStyle}>
					<Stack sx={{ width: "80%", margin: "auto" }} justifyContent="center">
						<Stack direction="row" sx={{ width: "100%", borderBottom: "2px solid", ...borderStyle }}>
							<Box sx={{ width: "50%", borderRight: "solid 2px", ...borderStyle }}>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="flex-start"
									sx={{ ...cardStyle, height: "21em" }}
								>
									<Typography
										variant="h5"
										sx={{ width: "100%", textAlign: "center", fontWeight: "bold", margin: "1em 0" }}
									>
										Existing Policies
									</Typography>
									<Stack direction="column" spacing={1} sx={{ width: "100%" }}>
										{policyService.companyPolicies.map((policy, i) => {
											if (i >= 4) return ( <React.Fragment key={`policy_list_item_${i}`}/> );
											return (
												<Stack
													key={`policy_list_item_${i}`}
													direction="row"
													alignItems="center"
													justifyContent="center"
													sx={{ "&:hover": { cursor: "pointer" }, margin: "0" }}	
													onClick={() => {handlePolicyClick(policy)}}
												>
													<FiberManualRecord sx={{ width: "0.3em", height: "0.3em" }}/>
													<Typography sx={{ width: "50%", margin: "0 0.5em" }}>
														{`${policy.name}`}
													</Typography>
													<ArrowBackIosNewIcon
														sx={{ transform: "rotate(270deg)", color: "#ff03ed" }}
													/>
												</Stack>
											);
										})}
									</Stack>
									<Stack
										direction="row"
										sx={{
											width: "10em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											border: `2px solid ${pink}`,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										onClick={handlePoliciesClick}
									>
										<Typography
											sx={{
												width: "100%",
												textAlign: "center"
											}}
										>
											All Policies
										</Typography>
									</Stack>
								</Stack>
							</Box>
							<Box sx={{ width: "50%", ...borderStyle }}>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="flex-start"
									spacing={2}
									sx={{ ...cardStyle, height: "21em" }}
								>
									<Typography
										variant="h5"
										sx={{ width: "100%", textAlign: "center", fontWeight: "bold", margin: "1em 0" }}
									>
										Policy Generator
									</Typography>
									<Stack
										direction="row"
										sx={{
											width: "10em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											border: `2px solid ${pink}`,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										onClick={handleSendPoliciesClick}
									>
									<Typography
											sx={{
												width: "100%",
												textAlign: "center"
											}}
										>
											Create Policy
										</Typography>
									</Stack>
									<Stack
										direction="row"
										sx={{
											width: "10em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											border: `2px solid ${pink}`,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										onClick={handlePolicyTemplatesClick}
									>
									<Typography
											sx={{
												width: "100%",
												textAlign: "center"
											}}
										>
											Policy Templates
										</Typography>
									</Stack>
									<Stack
										direction="row"
										sx={{
											width: "10em",
											height: "3.5em",
											marginTop: "2em",
											borderRadius: "2.5em",
											border: `2px solid ${pink}`,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										onClick={handlepolicyUploadClick}
									>
										<Typography
											sx={{
												width: "100%",
												textAlign: "center"
											}}
										>
											Upload Policy PDF
										</Typography>
									</Stack>
								</Stack>
							</Box>
						</Stack>
						<Stack direction="row" sx={{ width: "100%" }}>
							<Box sx={{ width: "50%", borderRight: "solid 2px", ...borderStyle }}>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="flex-start"
									sx={{ ...cardStyle, paddingBottom: "1em" }}
									spacing={3}
								>
									<Typography
										variant="h5"
										sx={{ width: "100%", textAlign: "center", fontWeight: "bold", marginTop: "2em" }}
									>
										Policy Tracker
									</Typography>
									<Stack direction="row" spacing={6}>
										<Stack direction="column" alignItems="center" justifyContent="center">
											<Typography>Total Live Policies</Typography>
											<Typography sx={{ fontWeight: "bold", fontSize: "1.5em" }}>
												{policyService.policyStats.totalLive}
											</Typography>
										</Stack>
										<Stack direction="column" alignItems="center" justifyContent="center">
											<Typography>Total Recipients</Typography>
											<Typography sx={{ fontWeight: "bold", fontSize: "1.5em" }}>
												{policyService.policyStats.totalRecipients}
											</Typography>
										</Stack>
									</Stack>
									<Stack direction="row" spacing={6}>
										<Stack direction="column" alignItems="center" justifyContent="center">
											<Typography>
												Sent Policies{` `}
												<span style={{ fontWeight: "bold" }}>Viewed</span>
											</Typography>
											<Typography sx={{ fontWeight: "bold", fontSize: "1.5em" }}>
												{policyService.policyStats.percentViewed}%
											</Typography>
										</Stack>
										<Stack direction="column" alignItems="center" justifyContent="center">
										<Typography>
												Sent Policies{` `}
												<span style={{ fontWeight: "bold" }}>Signed</span>
											</Typography>
											<Typography sx={{ fontWeight: "bold", fontSize: "1.5em" }}>
												{policyService.policyStats.percentSigned}%
											</Typography>
										</Stack>
									</Stack>
									<Stack
										direction="row"
										alignItems="center"
										justifyContent="center"
										spacing={6}
									>
										<PolicyPercentBar percent={`${policyService.policyStats.percentViewed}%`}/>
										<PolicyPercentBar percent={`${policyService.policyStats.percentSigned}%`}/>
									</Stack>
								</Stack>
							</Box>
							<Box sx={{ width: "50%", ...borderStyle }}>
								<Stack
									direction="column"
									alignItems="center"
									justifyContent="flex-start"
									sx={{ ...cardStyle }}
								>
									<Stack
										direction="row"
										sx={{
											width: "15em",
											height: "4em",
											marginTop: "5em",
											borderRadius: "2.5em",
											background: blueGradientBackground,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="flex-start"
									>
										<Typography
											sx={{
												fontWeight: "bold",
												color: "#ffffff",
												marginLeft: "1.5em",
												paddingLeft: "0.5em",
												width: "9em"
											}}
										>
											Policy Report
										</Typography>
										<ArrowCircleUpSharp
											sx={{
												width: "2.5em",
												height: "2.5em",
												transform: "rotate(90deg)",
												color: "#ffffff"
											}}
										/>
									</Stack>
									<Stack
										direction="row"
										sx={{
											width: "15em",
											height: "4em",
											marginTop: "2em",
											borderRadius: "2.5em",
											border: `2px solid ${pink}`,
											"&:hover": {
												cursor: "pointer"
											}
										}}
										alignItems="center"
										justifyContent="center"
										onClick={handleAuditPoliciesClick}
									>
										<Typography
											sx={{
												fontWeight: "bold",
												width: "100%",
												textAlign: "center"
											}}
										>
											Share Policies with<br/>
											External Auditor
										</Typography>
									</Stack>
								</Stack>
							</Box>
						</Stack>
					</Stack>
					<PoliciesModal
						open={showPolicies}
						onClose={handlePoliciesModalClose}
					/>
					<SendPoliciesModal
						open={showSendPolicies}
						onClose={handleSendPoliciesModalClose}
					/>
					<PolicyAuditorModal
						open={showAuditPolicies}
						onClose={handleAuditPoliciesModalClose}
					/>
					<PolicyTemplatesModal
						open={showPolicyTemplates}
						onClose={handlePolicyTemplatesModalClose}
					/>
					<PolicyUploadModal
						open={showPolicyUpload}
						onClose={handlePolicyUploadModalClose}
						onSubmit={handleUploadPolicySubmit}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default Policies;